/** Format programme times in the exhibition venue zone (match public site). */

export function formatVenueTime(
  iso: string,
  locale: string,
  timeZone = "Europe/Moscow",
): string {
  return new Date(iso).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  });
}

export function formatVenueDate(
  iso: string,
  locale: string,
  timeZone = "Europe/Moscow",
  opts?: Intl.DateTimeFormatOptions,
): string {
  return new Date(iso).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    timeZone,
    ...opts,
  });
}

export function formatVenueDateTime(
  iso: string,
  locale: string,
  timeZone = "Europe/Moscow",
): string {
  return new Date(iso).toLocaleString(locale, {
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  });
}
